<inform-owner>
  <div if="{ props.status === 0 }">
    <form class="modal-wrap" onsubmit="{ onSubmit }">
      <div class="msg-box">
        <p>日付: { props.date }</p><br>
        <p>{ props.msgText.substring(0, props.msgText.indexOf("正しくない場合")) }</p>
      </div>
      <div class="form-group">
        <label class="form-label">受け取った金額に誤りもしくは不正のある場合、ご連絡ください。</label>
        <textarea class="form-control" name="text" rows="7"></textarea>
      </div>
      <button class="btn btn-green">送信</button>
    </form>
  </div>

  <div if="{ props.status !== 0 }">
    <label class="form-label">通報の期限がすぎました。7日以内に連絡ください。</label>
  </div>

  <script>
    import { serializeForm } from '@/common/utils/dom';
    export default {
      async onBeforeMount() {
        await this.props.init(this.props.key);
      },

      onSubmit(e) {
        e.preventDefault();
        const data = serializeForm(e.target);
        const formData = {
          key: this.props.key,
          ...data
        };
        this.props.send(formData);
      },

    };
  </script>
  <style type="postcss">
    .btn {
      margin-top: 16px;
      width: 100%;
    }

    .link-group {
      margin-top: 16px;
      text-align: center;
    }

    .link+.link {
      margin-left: 14px;
    }

    .msg-box{
        padding: 0.5em 1em;
        color: #5d627b;
        background: white;
        border-top: solid 5px #5d627b;
        box-shadow: 0 3px 5px rgba(0, 0, 0, 0.22);
        margin-bottom: 5px;
    }

    .msg-box p {
        margin: 0; 
        padding: 0;
    }
  </style>
</inform-owner>